import axios from 'axios'
import { GroupResponse } from '../../common/GroupResponse'

type Props = {
  contactGroup: any
  redirectPath: string
}

export const putContactGroup = async (props: Props) => {
  const { contactGroup: group } = props
  return await axios.put<GroupResponse>(
    `${process.env.REACT_APP_API_URL}/contactGroup/${group.id}`,
    group,
    {
      withCredentials: true,
    },
  )
}
